<template>
  <div class="deal-grid text-sm font-medium text-text-secondary rounded py-3-5 items-center -mt-px group">
    <div class="text-text-ternary font-normal">
      {{ $moment.unix(deal.created_at).format('DD.MM.YY HH:mm') }}
    </div>
    <div class="flex items-center">
      <AssetIcon :instrument="deal.instrument" class="mr-3 -my-px"/>
      <div class="truncate">{{ instrumentTicker }}</div>
      <NoteEdit :id="deal.id"
                :note="deal.note"/>
    </div>
    <AssetType :asset-type="instrumentType"/>
    <EventType :deal_type="deal.type"/>
    <div class="text-right">{{ deal.amount }}</div>
    <div class="text-right">
      {{ displayCurrencyValue(deal.price, dealCurrency, true) }}
    </div>
    <div class="text-right">
      {{ displayCurrencyValue(commissionsSum, dealCurrency, true) }}
    </div>
    <div class="text-right">
      {{ displayCurrencyValue(deal.sum_full_base, {}, false) }}
    </div>
    <div class="flex justify-end items-center gap-4">
      <div class="cursor-pointer text-icon hover:text-icon-hover transition duration-200"
           @click="handleEdit"
           v-tooltip="$t('edit')">
        <IconEdit/>
      </div>
      <ArchiveBtn :submitted="deleting"
                  buttons-text-type="del-cancel"
                  @confirm="handleDelete">
      </ArchiveBtn>
    </div>
  </div>
</template>

<script>
import AssetIcon from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetIcon";
import IconDotsMore from "@/components/icons/IconDotsMore";
import IconEdit from "@/components/icons/IconEdit";
import EventType from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/EventType";
import AssetType from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/AssetType";
import NoteEdit from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/NoteEdit";
import ArchiveBtn from "@/components/UI/ArchiveBtn";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {dealTypes} from "@/utilities/invest_deal_types";

export default {
  name: "DealsListItem",
  components: {NoteEdit, AssetType, EventType, IconDotsMore, IconEdit, AssetIcon, ArchiveBtn},
  props: {
    deal: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deleting: false
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['getCurrencyByCode', 'displayCurrencyValue']),
    dealCurrency() {
      return this.getCurrencyByCode((this.deal.instrument && this.deal.instrument.currency) || 'RUB');
    },
    commissionsSum() {
      return this.deal.commission_broker + this.deal.commission_clearing + this.deal.commission_exchange;
    },
    instrumentTicker() {
      return (this.deal.instrument && this.deal.instrument.ticker) || '-';
    },
    instrumentType() {
      return (this.deal.instrument && this.deal.instrument.type) || null;
    }
  },
  methods: {
    ...mapActions('investments/deals', ['deleteDeal']),
    ...mapMutations('investments/modals', ['setEditingDeal', 'toggleModal']),
    handleEdit() {
      this.setEditingDeal(this.deal);
      const modalName = this.getEditModalName(this.deal.type);
      if (modalName) {
        this.toggleModal(modalName);
      }
    },
    getEditModalName(dealType) {
      switch (dealType) {
        case dealTypes.TYPE_BUY:
          return 'editDealBuy';
        case dealTypes.TYPE_SELL:
          return 'editDealSell';
        case dealTypes.TYPE_INCOME_DIVIDEND:
        case dealTypes.TYPE_INCOME_COUPON:
        case dealTypes.TYPE_INCOME_AMORTIZATION:
          return 'editManualIncome';
        case dealTypes.TYPE_EXPENSE_COMMISSION:
        case dealTypes.TYPE_EXPENSE_TAX:
          return 'editManualExpense';
        case dealTypes.TYPE_DEPOSITING:
          return 'editTransferIn';
        case dealTypes.TYPE_WITHDRAWAL:
          return 'editTransferOut';
        default:
          return null;
      }
    },
    async handleDelete() {
      this.deleting = true;
      try {
        const res = await this.deleteDeal(this.deal.id);
        if (res.body.success) {
          this.$toasted.success('Событие успешно удалено');
        } else {
          this.$toasted.error(res.body.message || 'Ошибка при удалении события');
        }
      } catch (err) {
        console.error(err);
        this.$toasted.error('Ошибка при удалении события');
      } finally {
        this.deleting = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        edit: 'Edit'
      },
      ru: {
        edit: 'Редактировать'
      }
    }
  }
}
</script>